// Shared across Products page and Repair / SSI Technical
export const PRODUCT_CATEGORIES = [
  'Desktop Computers',
  'Laptop Computers',
  'All-in-One Computers',
  'Workstation PCs',
  'Mini PCs',
  'Processors (CPU)',
  'Motherboards',
  'Graphics Cards (GPU)',
  'Desktop Memory (RAM)',
  'Laptop Memory (RAM)',
  'Power Supplies (PSU)',
  'Computer Cases',
  'Cooling Solutions',
  'Charger',
  'Internal SSDs',
  'Internal HDDs',
  'External Hard Drives',
  'USB Flash Drives',
  'Memory Cards',
  'Keyboards',
  'Computer Mice',
  'Webcams',
  'Speakers',
  'Headsets & Microphones',
  'Monitors',
  'Monitor Mounts',
  'Projectors',
  'Routers',
  'Switches',
  'Network Adapters',
  'Cables & Connectors',
  'Wi-Fi Extenders',
  'Gaming PCs',
  'Gaming Laptops',
  'Gaming Accessories',
  'VR Headsets',
  'Gaming Consoles',
  'Operating Systems',
  'Productivity Software',
  'Security Software',
  'Creative Software',
  'Utilities',
  'Laptop Bags & Cases',
  'Mouse Pads',
  'Mouse',
  'Cable Management',
  'Cleaning Supplies',
  'UPS & Surge Protectors',
  'Printers',
  'Scanners',
  'Ink & Toner',
  'Replacement Parts',
  'Tools & Kits',
  'Thermal Paste & Pads'
];

/** Categories used for warranty exchange / SSI Technical intake */
export const SSI_DEVICE_CATEGORIES = [
  'Desktop Computers',
  'Laptop Computers',
  'All-in-One Computers',
  'Workstation PCs',
  'Mini PCs',
  'Gaming PCs',
  'Gaming Laptops',
  'Monitors',
  'Printers',
  'Scanners',
  'Projectors',
  'Gaming Consoles',
  'VR Headsets',
  'Routers',
  'Switches'
];

export const SERIAL_TRACKED_CATEGORIES = [
  'Desktop Computers',
  'Laptop Computers',
  'All-in-One Computers',
  'Workstation PCs',
  'Monitors',
  'Projectors',
  'Printers',
  'Scanners',
  'Gaming Consoles',
  'VR Headsets',
  'Routers',
  'Switches',
  'Mini PCs',
  'Gaming PCs',
  'Gaming Laptops'
];
